import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import LeaderboardHero from 'flarum/gamilytics/forum/leaderboards/components/LeaderboardHero';
import IndexPageHero from 'flarum/newvigation/components/IndexPageHero';
import LeaderboardSidebar from 'flarum/gamilytics/forum/leaderboards/components/LeaderboardSidebar';

export default function addLeaderboardHero() {
	if (!app.initializers.has('glowingblue-newvigation')) return;

	override(LeaderboardHero.prototype, 'view', function () {
		if (!app.forum.attribute('glowingblue-gamilytics.gamification.enabled')) return;

		const title = app.translator.trans('glowingblue-orell-gamilytics.forum.hero.leaderboard');
		const icon = 'far fa-hiking';

		const navItems = LeaderboardSidebar.prototype.navItems();
		return <IndexPageHero title={title} icon={icon} navItems={navItems} />;
	});
}
